import IResource from '@app/core/model/resource';
import { IUser } from '@app/core/model/user';
import { CodeFeaturesService } from '../user/code-features.service';
import { UserSubscriptionService } from '../user/user-subscription.service';
import { isNullOrUndefined } from 'util';
import { IApiResponseWrapper } from '@app/core/model/v2-api/v2-api-wrappers';
import { BulkUpdateResponse } from '@app/core/bsshapi/api-wrappers';
import { genericRetryWhen, observableEmitDelay } from '@app/core/rxjsutils/rxjs-utilities';
import { BsApiEndPoints } from '../bs-api/endpoints';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { retryWhen, delay } from 'rxjs/operators';

export interface IRestoreService {
  canRestore(resources: IResource[], user: IUser);
  restore(runIds: Array<string>, datasetIds: Array<string>);
}

@Injectable({
  providedIn: 'root'
})
export class RestoreService implements IRestoreService {

  constructor(private httpClient: HttpClient,
              private codeFeaturesService: CodeFeaturesService,
              private userSubscriptionService: UserSubscriptionService) { }

  public canRestore(resources: IResource[], user: IUser) {

    if (isNullOrUndefined(resources) || isNullOrUndefined(user)) {
      return false;
    }

    if (isNullOrUndefined(user)
      || !this.codeFeaturesService.archivingIsEnabled
      || !this.userSubscriptionService.hasCommercialSubscription()) {
      return false;
    }

    return resources.some(resource => !isNullOrUndefined(resource) && resource.IsArchived && resource.UserOwnedBy && 
     resource.UserOwnedBy.Id === user.Id);

  }

  public restore(runIds: Array<string>, datasetIds: Array<string>): Observable<IApiResponseWrapper<BulkUpdateResponse>> {
    const postData = { RunIds: runIds, DatasetIds: datasetIds, Id: null };

    return this.httpClient.post<IApiResponseWrapper<BulkUpdateResponse>>(BsApiEndPoints.RESTORE_URL, postData).pipe(
      // Retry in case of HTTP errors
      retryWhen(genericRetryWhen()),
      // To avoid a Flash of content, maintain a delay
      delay(observableEmitDelay),
    );
  }
}
